import script from "./HTAIGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTAIGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTAIGamePlay.vue?vue&type=style&index=0&id=5ff97bc3&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff97bc3"]])

export default __exports__